const itemHeight = { base: "4rem" };
const itemXPadding = "1.5rem";
const reducedWidth = "4.5rem";
const leftSideBeforeElementSize = "13px";
export function getLinkItemBg(backOfficeMode) {
    return backOfficeMode
        ? "semantic.brand.tertiary-dimmed"
        : "semantic.brand.secondary-dimmed";
}
const getLeftSideBeforeElementCssWithColor = (color) => ({
    content: '""',
    width: 0,
    height: 0,
    borderTop: `${leftSideBeforeElementSize} solid transparent`,
    borderBottom: `${leftSideBeforeElementSize} solid transparent`,
    borderLeft: `${leftSideBeforeElementSize} solid`,
    borderLeftColor: color,
    position: "relative",
    right: 0,
    transform: `translateX(-${itemXPadding})`,
    display: { base: "none", md: "block" },
});
const expandItemStyle = {
    height: itemHeight,
    px: itemXPadding,
    backgroundColor: "semantic.foreground.primary",
    color: "semantic.text.inverse",
    transitionDuration: "normal",
    transitionProperty: "common",
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    _hover: {
        backgroundColor: "semantic.brand.tertiary-dimmed",
        color: "semantic.text.primary",
        textDecoration: "none",
    },
    _active: {
        backgroundColor: "semantic.cta.secondaryPressed",
        color: "semantic.text.inverse",
    },
    _focusVisible: {
        backgroundColor: "semantic.brand.tertiary-dimmed",
        color: "semantic.text.primary",
        border: "3px solid",
        borderColor: "semantic.outline.focus",
        outline: "none",
    },
};
const baseItemStyle = (isNested, isNestedRoot, isSelected, hasSelectedSiblings, backOfficeMode) => ({
    height: itemHeight,
    px: itemXPadding,
    backgroundColor: isNested && hasSelectedSiblings
        ? getLinkItemBg(backOfficeMode)
        : "semantic.foreground.primary",
    color: isNested && hasSelectedSiblings
        ? "semantic.text.primary"
        : "semantic.text.inverse",
    borderLeft: (isNestedRoot && isSelected) || hasSelectedSiblings ? "2px solid" : "none",
    borderLeftColor: backOfficeMode
        ? "semantic.brand.tertiary"
        : "semantic.brand.secondary",
    transitionDuration: "normal",
    transitionProperty: "common",
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    _hover: {
        backgroundColor: isNested
            ? "semantic.cta.secondaryHoverStrong"
            : "semantic.brand.tertiary-dimmed",
        color: "semantic.text.primary",
        textDecoration: "none",
        _before: isNestedRoot
            ? {}
            : getLeftSideBeforeElementCssWithColor("semantic.brand.tertiary-light"),
        "& > :first-child": isNestedRoot
            ? {}
            : {
                ml: {
                    md: `-${leftSideBeforeElementSize}`,
                    lg: `-${leftSideBeforeElementSize}`,
                    xl: `-${leftSideBeforeElementSize}`,
                    "2xl": `-${leftSideBeforeElementSize}`,
                },
            },
    },
    _active: Object.assign({ backgroundColor: "semantic.cta.secondaryPressed", color: "semantic.text.inverse", _before: isNestedRoot
            ? {}
            : getLeftSideBeforeElementCssWithColor("semantic.brand.tertiary-light") }, (isNestedRoot || (isNested && isSelected)
        ? {}
        : {
            "& > :first-child": {
                ml: {
                    md: `-${leftSideBeforeElementSize}`,
                    lg: `-${leftSideBeforeElementSize}`,
                    xl: `-${leftSideBeforeElementSize}`,
                    "2xl": `-${leftSideBeforeElementSize}`,
                },
            },
        })),
    _focusVisible: Object.assign({ backgroundColor: "semantic.brand.tertiary-dimmed", color: "semantic.text.primary", border: "3px solid", borderColor: "semantic.outline.focus", outline: "none", _before: getLeftSideBeforeElementCssWithColor("semantic.brand.tertiary-light") }, (isNestedRoot || (isNested && isSelected)
        ? {}
        : {
            "& > :first-child": {
                ml: {
                    md: `-${leftSideBeforeElementSize}`,
                    lg: `-${leftSideBeforeElementSize}`,
                    xl: `-${leftSideBeforeElementSize}`,
                    "2xl": `-${leftSideBeforeElementSize}`,
                },
            },
        })),
});
export { baseItemStyle, expandItemStyle, reducedWidth, itemHeight, itemXPadding, getLeftSideBeforeElementCssWithColor, leftSideBeforeElementSize, };
//# sourceMappingURL=SideMenu.styles.js.map